export default "__VITE_ASSET__$QvfHdkV__"